import React from 'react';
import { useModules } from '../contexts/ModulesContext';
import { usePermissions } from '../hooks/usePermissions';
import { isSaasAdminRole } from '../utils/iamRoles';

const ModuleProtectedRoute = ({ children, route }) => {
  const { isRouteEnabled, loading } = useModules();
  const { role } = usePermissions();
  /** Seul le SaaS admin contourne les modules désactivés (ex. hors abonnement) — les admins org respectent le périmètre licence. */
  const isSaasAdmin = isSaasAdminRole(role);

  // Si les modules sont en cours de chargement, attendre
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  // Si la route n'est pas activée, bloquer (sauf saas_admin plateforme)
  if (route && !isRouteEnabled(route) && !isSaasAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Module indisponible</h2>
            <p className="text-gray-600 mb-6">
              Cette fonctionnalité n’est pas incluse dans l’abonnement de votre organisation ou a été désactivée.
            </p>
            <button
              onClick={() => window.history.back()}
              className="w-full px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition font-medium shadow-lg hover:shadow-xl"
            >
              Retour
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ModuleProtectedRoute;

